import React, { Component } from 'react';

class EventButtons extends Component {
	render() {
		return <span>
			<a className="btn btn-default btn-event-details" href={ this.props.link }>Event Details</a>&nbsp;
			<a className="btn btn-default btn-register-now" href={ `${this.props.link}register` }>Register Now</a>
		</span>;
	}
}

export default EventButtons;